import React from "react";
import Images from "../assets/AllImages";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="px-4 px-md-5">
        <div className="row">
          <div className="col-lg-3 col-md-6 mb-4">
            <div className="footer-logo mb-4">
              <img
                src={Images.FooterLogo}
                alt="Step Arena"
                className="mb-3"
                style={{ height: "50px" }}
              />
              <h5 className="fw-bold text-white"></h5>
              <p className="text-light" style={{ fontSize: "18px", lineHeight: "1.6" }}>
                {/* optional tagline goes here via t("tagline") if you add it */}
              </p>
            </div>
          </div>

          <div className="col-lg-2 col-md-8 mb-4">
            <h5 className="fw-bold text-white mb-3" style={{ fontSize: "20px" }}>
              {t("quickLinks")}
            </h5>
            <ul className="list-unstyled q-links">
              <li className="mb-2">
                <a href="/about" className="text-decoration-none text-light" style={{ fontSize: "18px" }}>
                  {t("aboutus")}
                </a>
              </li>
              <li className="mb-2">
                <a href="/outdoor" className="text-decoration-none text-light" style={{ fontSize: "18px" }}>
                  {t("outdoor")}
                </a>
              </li>
              <li className="mb-2">
                <a href="/indoor" className="text-decoration-none text-light" style={{ fontSize: "18px" }}>
                  {t("indoor")}
                </a>
              </li>
              <li className="mb-2">
                <a href="/contact" className="text-decoration-none text-light" style={{ fontSize: "18px" }}>
                  {t("kontakt")}
                </a>
              </li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="fw-bold text-white mb-3" style={{ fontSize: "20px" }}>
              {t("services")}
            </h5>
            <ul className="list-unstyled q-links">
              <li className="mb-2">
                <a href="/events" className="text-decoration-none text-light" style={{ fontSize: "18px" }}>
                  {t("event")}
                </a>
              </li>
              <li className="mb-2">
                <a href="/membership" className="text-decoration-none text-light" style={{ fontSize: "18px" }}>
                  {t("anetaresim")}
                </a>
              </li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-6 mb-4">
            <h5 className="fw-bold text-white mb-3" style={{ fontSize: "22px" }}>
              {t("contact")}
            </h5>

            <div className="contact-info">
              <p className="text-light mb-2" style={{ fontSize: "20px" }}>
                <strong>{t("email")}:</strong>
                <br />
                <a
                  href="mailto:info@step-ks.com"
                  className="text-light text-decoration-none"
                  style={{ fontSize: "18px" }}
                >
                  info@step-ks.com
                </a>
              </p>

              <p className="text-light mb-3" style={{ fontSize: "20px" }}>
                <strong>{t("phone")}:</strong>
                <br />
                <a
                  href="tel:048334000"
                  className="text-light text-decoration-none"
                  style={{ fontSize: "18px" }}
                >
                  048 334 000
                </a>
              </p>

              <div className="social-icons">
                <a href="#" target="_blank" rel="noreferrer" className="me-3">
                  <i className="bi bi-facebook" style={{ fontSize: "1.5rem" }}></i>
                </a>
                <a href="#" target="_blank" rel="noreferrer" className="me-3">
                  <i className="bi bi-twitter" style={{ fontSize: "1.5rem" }}></i>
                </a>
                <a href="#" target="_blank" rel="noreferrer" className="me-3">
                  <i className="bi bi-instagram" style={{ fontSize: "1.5rem" }}></i>
                </a>
                <a href="#" target="_blank" rel="noreferrer">
                  <i className="bi bi-linkedin" style={{ fontSize: "1.5rem" }}></i>
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-2 col-md-12 mb-4">
            <div className="footer-vator text-center">
              <img src={Images.Vactor} alt="Step Arena Vector" className="img-fluid" />
            </div>
          </div>
        </div>

        <hr className="my-4" style={{ borderColor: "rgba(255,255,255,0.1)" }} />

        <div className="row">
          <div className="col-12 text-center">
            <p className="mb-0 text-light" style={{ fontSize: "18px" }}>
              © 2025 Step Arena. {t("rightsReserved")} | {t("privacyPolicy")} | {t("termsOfService")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
